import { type GlobalSearchResultTypeEnum } from '../enums'
import { type GlobalSearchItemMetadata } from '../GlobalSearchItemMetadata'

export interface GlobalSearchResultItemConstructor {
  type: GlobalSearchResultTypeEnum
  uuid: string
  id: string
  label?: string
  metadata: GlobalSearchItemMetadata
}

export class GlobalSearchResultItem {
  readonly type: GlobalSearchResultTypeEnum
  readonly uuid: string
  readonly id: string
  readonly label: Nullable<string>
  readonly metadata: GlobalSearchItemMetadata

  constructor(data: GlobalSearchResultItemConstructor) {
    this.type = data.type
    this.uuid = data.uuid
    this.id = data.id
    this.label = data.label ?? null
    this.metadata = data.metadata
  }
}
